import React, { useState } from "react";
import { Plus, Minus, Check } from "lucide-react";
import { useBasket } from "../contexts/BasketContext";
import WineDetailDialog from "./WineDetailDialog";

export default function WineCard({ wine, images = [] }) {
  const [qty, setQty] = useState(1);
  const [added, setAdded] = useState(false);
  const [detail, setDetail] = useState(false);
  const { add } = useBasket();
  const main = images[0];
  const meta = [wine.vintage, wine.sweetness].filter((v) => v && String(v).trim());

  const handleAdd = () => {
    add(wine, qty);
    setAdded(true);
    setTimeout(() => setAdded(false), 1400);
  };

  return (
    <article data-testid={`wine-card-${wine.slug}`} className="bg-ivory border border-charcoal/10 hover:border-burgundy/40 transition-colors overflow-hidden flex flex-col">
      <div className="aspect-[4/5] overflow-hidden bg-cream">
        {main ? (
          <img src={main.src} alt={main.alt} className="w-full h-full object-cover transition-transform duration-700 hover:scale-[1.03]" loading="lazy" />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-burgundy/25 font-serif text-4xl italic select-none" aria-hidden="true">{wine.name.charAt(0)}</div>
        )}
      </div>
      <div className="p-5 md:p-6 flex-1 flex flex-col">
        <h3 className="font-serif text-xl text-charcoal">{wine.name}</h3>
        {meta.length > 0 && <div className="mt-1 text-xs text-charcoal/60" data-testid={`wine-meta-${wine.slug}`}>{meta.join(" · ")}</div>}
        <div className="mt-4 flex items-baseline gap-1">
          <span className="font-serif text-2xl text-burgundy" data-testid={`wine-price-${wine.slug}`}>{wine.price}</span>
          <span className="text-sm text-charcoal/70">Kč / láhev</span>
        </div>

        <div className="mt-auto pt-5 flex items-center gap-3">
          <div className="inline-flex items-center border border-charcoal/20">
            <button type="button" data-testid={`wine-qty-dec-${wine.slug}`} onClick={() => setQty((q) => Math.max(1, q - 1))} className="p-2 hover:bg-cream" aria-label="Snížit počet">
              <Minus size={14} />
            </button>
            <span data-testid={`wine-qty-${wine.slug}`} className="w-9 text-center text-sm">{qty}</span>
            <button type="button" data-testid={`wine-qty-inc-${wine.slug}`} onClick={() => setQty((q) => Math.min(999, q + 1))} className="p-2 hover:bg-cream" aria-label="Zvýšit počet">
              <Plus size={14} />
            </button>
          </div>
          <button type="button" data-testid={`wine-add-${wine.slug}`} onClick={handleAdd}
            className="flex-1 bg-burgundy hover:bg-burgundy-hover text-ivory text-sm py-2.5 tracking-wide inline-flex items-center justify-center gap-2">
            {added ? (<><Check size={16} /> Přidáno</>) : "Přidat do poptávky"}
          </button>
        </div>
        <button type="button" onClick={() => setDetail(true)} data-testid={`wine-more-${wine.slug}`}
          className="mt-3 border border-charcoal/20 hover:border-burgundy hover:text-burgundy text-sm py-2.5 tracking-wide transition-colors">
          Více o víně
        </button>
      </div>
      <WineDetailDialog wine={wine} images={images} open={detail} onOpenChange={setDetail} />
    </article>
  );
}
